import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsform',
	templateUrl:'./BSFormPluginCompPage.html',
	styles: [],
	styleUrls:['./BSFormPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSFormPluginCompPage
{
	mdContent_821 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.forms.BSForm;
\`\`\``;
	mdContent_822 = `\`\`\`java
BSForm()
\`\`\``;
	mdContent_823 = `\`\`\`java
BSForm&lt;?&gt; form = new BSForm&lt;&gt;();
BSFormGroup&lt;?&gt; email = form.addGroup("email", "Email", new InputEmailType&lt;&gt;());
BSFormGroup&lt;?&gt; pass = form.addGroup("password", "Password", new InputPasswordType&lt;&gt;());
form.add(new BSButton&lt;&gt;("Login").setPrimary(true));
\`\`\``;
}
